import { useCallback, useState } from 'react';

import { AppImageSourceTab } from './appImageSourceTypes';

/** 应用镜像来源弹窗状态编排 */
export function useAppImageSourceModal(initialTab: AppImageSourceTab = AppImageSourceTab.Repo) {
  const [modalVisible, setModalVisible] = useState(false);
  const [modalSession, setModalSession] = useState(0);
  const [sourceTab, setSourceTab] = useState<AppImageSourceTab>(initialTab);

  const openModal = useCallback((tab?: AppImageSourceTab) => {
    if (tab) setSourceTab(tab);
    setModalSession((session) => session + 1);
    setModalVisible(true);
  }, []);

  const closeModal = useCallback(() => {
    setModalVisible(false);
  }, []);

  const handleSourceTabChange = useCallback((tab: AppImageSourceTab) => {
    setSourceTab(tab);
    setModalSession((session) => session + 1);
  }, []);

  return {
    modalVisible,
    modalSession,
    sourceTab,
    openModal,
    closeModal,
    handleSourceTabChange,
  };
}
